export default __webpack_public_path__ + "static/media/BackgroundVideo.3327456b.svg";